const $86b13480c2360751$export$4155fae302b916c9 = async ()=>{
    const res = await fetch("http://localhost:3000/icecream");
    if (!res.ok) throw new Error("Failed!");
    return res.json();
}; // export const getIceAPI = () => {
 //   return fetch("http://localhost:3000/icecream").then((res) => res.json());
 // };


const $b4413bcb37a0ad9a$export$1ed6294efb83e2ac = async (iceCream)=>{
    const options = {
        method: "POST",
        body: JSON.stringify(iceCream),
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    };
    const res = await fetch("http://localhost:3000/icecream", options);
    if (!res.ok) throw new Error("Failed!");
    return res.json();
}; // export const postIceAPI = (iceCream) => {
 // const options = {
 // method: "POST",
 // body: JSON.stringify(iceCream),
 // headers: {
 // "Content-Type": "application/json; charset=UTF-8",
 // },
 // };
 //   return fetch("http://localhost:3000/icecream", options).then((res) => res.json());
 // };


const $a50e240db88156af$export$8b88e9c6feb9b09b = async (id)=>{
    const res = await fetch(`http://localhost:3000/icecream/${id}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error("Failed!");
    return res.json();
}; // export const delIceAPI = (id) => {
 //     return fetch(`http://localhost:3000/icecream/${id}`, {
 //         method: "DELETE",
 //     }).then((res) => res.json());
 // }


const $cbdf6a511dbeaa6a$export$2f74d05eb6079dc3 = async (id, icecream)=>{
    const options = {
        method: "PUT",
        body: JSON.stringify(icecream),
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    };
    const res = await fetch(`http://localhost:3000/icecream/${id}`, options);
    if (!res.ok) throw new Error("Failed!");
    return res.json();
}; // export const upddateIceApi = (id, icecream) => {
 //     const options = {
 //     method: "PUT",
 //     body: JSON.stringify(icecream),
 //     headers: {
 //     "Content-Type": "application/json; charset=UTF-8",
 // }}
 //     return fetch(`http://localhost:3000/icecream/${id}`, options).then((res) => res.json())
 // }


const $6f40c3a58f594b58$var$list = document.querySelector(".list");
const $6f40c3a58f594b58$var$addBtn = document.querySelector(".add-btn");
const $6f40c3a58f594b58$var$backdropEl = document.querySelector(".backdrop");
const $6f40c3a58f594b58$var$formEl = document.querySelector(".modal-form");
let $6f40c3a58f594b58$var$currentEdit = null;
// getIceAPI().then((res) => renderLayout(res));
const $6f40c3a58f594b58$var$init = async ()=>{
    const res = await (0, $86b13480c2360751$export$4155fae302b916c9)();
    $6f40c3a58f594b58$var$renderLayout(res);
};
$6f40c3a58f594b58$var$init();
function $6f40c3a58f594b58$var$renderLayout(array) {
    const item = array.map(({ id: id, flavour: flavour, type: type, price: price, description: description, image: image })=>{
        return `<li id="${id}" class="item">
            <img src="${image}" alt="${type}" class="item-img">
            <h3 class="item-flavour">${flavour}</h3>
            <p class="item-type">${type}</p>
            <p class="item-price">$<span class="span">${price}</span></p>
            <p class="item-desc">${description}</p>
            <div class="btn-wrapper"> <button data-action="delete" type="button" class="button">Delete</button>
            <button data-action="edit" type="button" class="button">Edit</button>
        </div>
        </li>`;
    }).join("");
    $6f40c3a58f594b58$var$list.innerHTML = item;
}
//modal---------------
$6f40c3a58f594b58$var$addBtn.addEventListener("click", ()=>{
    $6f40c3a58f594b58$var$openModal();
});
function $6f40c3a58f594b58$var$openModal() {
    $6f40c3a58f594b58$var$backdropEl.style.display = "flex";
}
function $6f40c3a58f594b58$var$closeModal() {
    $6f40c3a58f594b58$var$backdropEl.style.display = "none";
}
$6f40c3a58f594b58$var$formEl.addEventListener("submit", async (event)=>{
    event.preventDefault();
    const elements = event.currentTarget.elements;
    const icecreamData = {
        flavour: elements.flavour.value.trim(),
        type: elements.type.value.trim(),
        price: elements.price.value.trim(),
        description: elements.desc.value.trim(),
        image: elements.url.value.trim()
    };
    if ($6f40c3a58f594b58$var$currentEdit === null) {
        //   postIceAPI(icecreamData).then((res) => {
        //   formEl.reset()
        //   closeModal()
        //   getIceAPI().then((res) => renderLayout(res));
        // }) 
        await (0, $b4413bcb37a0ad9a$export$1ed6294efb83e2ac)(icecreamData);
        $6f40c3a58f594b58$var$formEl.reset();
        $6f40c3a58f594b58$var$closeModal();
        const res = await (0, $86b13480c2360751$export$4155fae302b916c9)();
        $6f40c3a58f594b58$var$renderLayout(res);
    }
    if ($6f40c3a58f594b58$var$currentEdit) {
        // upddateIceApi(currentEdit,icecreamData).then(res => {
        //   formEl.reset()
        //   closeModal()
        //   getIceAPI().then((res) => renderLayout(res));
        // })
        await (0, $cbdf6a511dbeaa6a$export$2f74d05eb6079dc3)($6f40c3a58f594b58$var$currentEdit, icecreamData);
        $6f40c3a58f594b58$var$formEl.reset();
        $6f40c3a58f594b58$var$closeModal();
        const res = await (0, $86b13480c2360751$export$4155fae302b916c9)();
        $6f40c3a58f594b58$var$renderLayout(res);
        $6f40c3a58f594b58$var$currentEdit = null;
    }
});
$6f40c3a58f594b58$var$list.addEventListener("click", async (event)=>{
    const action = event.target.dataset.action;
    if (!action) return;
    // const li = event.target.parentNode.parentNode
    const li = event.target.closest("li");
    const id = li.id;
    if (action === "delete") {
        // delIceAPI(id).then(res => getIceAPI(res)).then(res => renderLayout(res))
        await (0, $a50e240db88156af$export$8b88e9c6feb9b09b)(id);
        const res = await (0, $86b13480c2360751$export$4155fae302b916c9)();
        console.log(res);
        $6f40c3a58f594b58$var$renderLayout(res);
    }
    if (action === "edit") {
        $6f40c3a58f594b58$var$currentEdit = id;
        $6f40c3a58f594b58$var$formEl.elements.url.value = li.querySelector(".item-img").src;
        $6f40c3a58f594b58$var$formEl.elements.flavour.value = li.querySelector(".item-flavour").textContent;
        $6f40c3a58f594b58$var$formEl.elements.type.value = li.querySelector(".item-type").textContent;
        $6f40c3a58f594b58$var$formEl.elements.price.value = li.querySelector(".span").textContent;
        $6f40c3a58f594b58$var$formEl.elements.desc.value = li.querySelector(".item-desc").textContent;
        $6f40c3a58f594b58$var$openModal();
    }
});


//# sourceMappingURL=ctud-fe-1-8.b8eb2764.js.map
